exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.sort-label[data-v-5d838553] {\n\tdisplay: -webkit-inline-box;\n\tdisplay: -ms-inline-flexbox;\n\tdisplay: inline-flex;\n\t-webkit-box-align: center;\n\t    -ms-flex-align: center;\n\t        align-items: center;\n}\n.sort-tip-icon[data-v-5d838553] {\n\tmargin-right: 4px;\n\tcolor: #c0c4cc;\n\tcursor: pointer;\n}\n.activity-datetime-range[data-v-5d838553] {\n\twidth: 456px !important;\n\tmax-width: 100%;\n}\n.activity-datetime-range[data-v-5d838553]  .el-range-input {\n\tmin-width: 0;\n}\n", ""]);

// exports
